import React from 'react';

const ReactHighcharts = require('react-highcharts');

class AutoclaveCicloGraficoAlarmes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { ciclo, tagAlarmes } = this.props;

        if (!ciclo || ciclo.length < 1) { return null; }

        var baseCategories = [
            'Evento',
            'Contactora Aquecimento',
            'Termostato',
            'Pressostato',
            'Porta Aberta',
            'Envelope vazamento',
            'Saco ar vazamento',
            'Ar descarga',
            'CLP bateria',
            'Trip',
            'Ventilador ligar',
            'Sensor Autoclave',
            'Envelope pressão baixa',
            'Saco ar pressão baixa',
            'Autoclave pressão baixa',
            'Envelope pressão alta',
            'Saco ar pressão alta',
            'Autoclave pressão alta',
            'Autoclave temperatura alta',
            'Autoclave temperatura baixa',
            'Supervisor aquecimento',
            'Supervisor Envelope',
            'Supervisor Saco Ar',
            'Supervisor Autoclave',
            'PT100',
            'Sem energia',
            'Ventilador',
            'Emergência'
        ];

        var baseSeries = [
            { name: 'Contactora Aquecimento', data: ciclo.alarmeFalhaRetornoContactoraAquecimento, showInLegend: false },
            { name: 'Termostato', data: ciclo.alarmeTermostato, showInLegend: false },
            { name: 'Pressostato', data: ciclo.alarmePressostato, showInLegend: false },
            { name: 'Porta Aberta', data: ciclo.alarmePortaAutoclaveAberta, showInLegend: false },
            { name: 'Envelope descarga', data: ciclo.alarmeDescargaEnvelope, showInLegend: false },
            { name: 'Saco ar descarga', data: ciclo.alarmeDescargaSacoDeAr, showInLegend: false },
            { name: 'CLP bateria', data: ciclo.alarmeBateriaCLP, showInLegend: false },
            { name: 'Trip', data: ciclo.alarmeTripAquecimento, showInLegend: false },
            { name: 'Ventilador ligar', data: ciclo.alarmeFalhaAcionamentoVentilador, showInLegend: false },
            { name: 'Sensor Envelope', data: ciclo.alarmeFalhaSensorEnvelope, showInLegend: false },
            { name: 'Sensor Autoclave', data: ciclo.alarmeFalhaSensorAutoclave, showInLegend: false },
            { name: 'Envelope pressão baixa', data: ciclo.alarmePressaoBaixaEnvelope, showInLegend: false },
            { name: 'Saco ar pressão baixa', data: ciclo.alarmePressaoBaixaSacoDeAr, showInLegend: false },
            { name: 'Autoclave pressão baixa', data: ciclo.alarmePressaoBaixa, showInLegend: false },
            { name: 'Envelope pressão alta', data: ciclo.alarmePressaoAltaEnvelope, showInLegend: false },
            { name: 'Saco ar pressão alta', data: ciclo.alarmePressaoAltaSacoDeAr, showInLegend: false },
            { name: 'Autoclave pressão alta', data: ciclo.alarmePressaoAlta, showInLegend: false },
            { name: 'Autoclave temperatura alta', data: ciclo.alarmeTemperaturaAlta, showInLegend: false },
            { name: 'Autoclave temperatura baixa', data: ciclo.alarmeTemperaturaBaixa, showInLegend: false },
            { name: 'Supervisor aquecimento', data: ciclo.alarmeSupervisaoAquecimento, showInLegend: false },
            { name: 'Supervisor Envelope', data: ciclo.alarmeSupervisaoPressaoEnvelope, showInLegend: false },
            { name: 'Supervisor Saco Ar', data: ciclo.alarmeSupervisaoPressaoSacoDeAr, showInLegend: false },
            { name: 'Supervisor pressão Autoclave', data: ciclo.alarmeSupervisaoPressaoAutoclave, showInLegend: false },
            { name: 'PT100', data: ciclo.alarmePT100, showInLegend: false },
            { name: 'Sem energia', data: ciclo.alarmeFaltaEnergia, showInLegend: false },
            { name: 'Ventilador', data: ciclo.alarmeVentilador, showInLegend: false },
            { name: 'Emergência', data: ciclo.alarmeEmergencia, showInLegend: false }
        ];

        var hasTagAlarmes = tagAlarmes && tagAlarmes.series && tagAlarmes.series.length > 0;

        var yCategories;
        var allSeries;
        var maxY;

        if (hasTagAlarmes) {
            // Tag alarms available: show ONLY tag alarms (they include everything)
            var expectedLen = ciclo.categoria ? ciclo.categoria.length : 0;

            yCategories = tagAlarmes.categories;
            maxY = yCategories.length;

            allSeries = tagAlarmes.series.map(function(s) {
                var data = s.data.slice();

                if (expectedLen > 0) {
                    if (data.length < expectedLen) {
                        var padding = new Array(expectedLen - data.length).fill(null);
                        data = data.concat(padding);
                    } else if (data.length > expectedLen) {
                        data = data.slice(0, expectedLen);
                    }
                }

                return {
                    name: s.name,
                    data: data,
                    showInLegend: false
                };
            });
        } else {
            // No tag data: fallback to fixed alarm indicators
            yCategories = baseCategories.slice();
            allSeries = baseSeries.slice();
            maxY = baseCategories.length;
        }

        var chartdata = {
            chart: {
                type: 'line',
                zoomType: 'x',
                animation: false
            },
            legend: {
                enabled: false
            },
            title: {
                text: ''
            },
            plotOptions: {
                line: {
                    turboThreshold: 0,
                    marker: {
                        enabled: true,
                        radius: 2
                    }
                }
            },
            xAxis: {
                categories: ciclo.categoria,
                title: {
                    text: 'Tempo em minutos do Processo - Vulcanização'
                }
            },
            yAxis: {
                tickInterval: 1,
                min: 0,
                max: maxY,
                tickmarkPlacement: 'on',
                minorTickLength: 1,
                minorTickWidth: 1,
                labels: {
                    step: 1,
                    formatter: function () {
                        return this.value;
                    }
                },
                title: {
                    text: ''
                },
                endOnTick: false,
                categories: yCategories
            },
            series: allSeries
        };

        return (
            <React.Fragment>
                <ReactHighcharts config={chartdata}></ReactHighcharts>
            </React.Fragment>
        );
    }
}

export default AutoclaveCicloGraficoAlarmes;
